import { MAP_TYPES } from '@deck.gl/carto';

const BROWARDMTPRESILIENCEROADNETWORK_SOURCE_ID = 'browardMTPResilienceRoadNetworkSource';

const source = {
  id: BROWARDMTPRESILIENCEROADNETWORK_SOURCE_ID,
  type: MAP_TYPES.TILESET,
  connection: 'bmpo-smartmetro-09142026',
  data: 'us-con-gcp-npr-0000424-011325.bmpo_curated_dev.Broward_MTP_Resilience_Road_Network11012023_tileset',
};

export default source;
